import { useState } from 'react';
import { Navigate, useLocation, useNavigate } from 'react-router-dom';
import { LoginPage as SharedLoginPage } from '@dikonek/ui-common';
import { useAuth } from '../auth/AuthContext';
import logo from '../assets/dikonek dark mode.png';

export function LoginPage() {
  const { authenticated, login } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const [error, setError] = useState<string | null>(null);
  const [busy, setBusy] = useState(false);

  if (authenticated) {
    const from = (location.state as { from?: string } | null)?.from ?? '/projects';
    return <Navigate to={from} replace />;
  }

  const handleLogin = async (username: string, password: string) => {
    setError(null);
    setBusy(true);
    try {
      await login(username.trim(), password);
      const from = (location.state as { from?: string } | null)?.from ?? '/projects';
      navigate(from, { replace: true });
    } catch (err) {
      setError(err instanceof Error ? err.message : 'Login failed');
    } finally {
      setBusy(false);
    }
  };

  return (
    <SharedLoginPage
      appName="Dikonek Projects Monitoring"
      subtitle="Track delivery, end to end."
      logo={logo}
      logoHeight={144}
      onLogin={handleLogin}
      loading={busy}
      errorMessage={error}
      forgotPasswordHref="/forgot-password"
    />
  );
}
